import axios from "../../interceptors/axiosInterceptor";
import { FETCH_UC_DETAILS_URL } from "../../config/Url";
import { IZoneInfoState } from "../../interfaces/Index";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import { normalizeUCDetailsResponse } from "../../normalizer/ZoneNormalizer";

export const fetchUCDetailsApiCall = (ucId: string) =>
  new Promise<IZoneInfoState>((resolve, reject) => {
    axios
      .get(FETCH_UC_DETAILS_URL.replace("{ucId}", ucId), getAuthOptions())
      .then((response) => {
        if (!response) reject({ errors: "Error fetching UC Details" });
        resolve(normalizeUCDetailsResponse(response.data));
      })
      .catch((error) => reject(normalizeCatchErrors(error.response)));
  });
